import { render, staticRenderFns } from "./PaymentFormPage.vue?vue&type=template&id=50228c1c&"
import script from "./PaymentFormPage.vue?vue&type=script&lang=js&"
export * from "./PaymentFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports